import { render, staticRenderFns } from "./AddJcomOnlinePayment.vue?vue&type=template&id=7713b70c&scoped=true"
import script from "./AddJcomOnlinePayment.vue?vue&type=script&lang=js"
export * from "./AddJcomOnlinePayment.vue?vue&type=script&lang=js"
import style0 from "./AddJcomOnlinePayment.vue?vue&type=style&index=0&id=7713b70c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7713b70c",
  null
  
)

export default component.exports